import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("prepcheck_token");
        if (!token) { setUser(null); setLoading(false); return; }
        try {
            const r = await api.get("/auth/me");
            setUser(r.data);
        } catch (e) {
            setAuthToken(null);
            setUser(null);
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        setAuthToken(r.data.token);
        setUser(r.data.user);
        return r.data.user;
    };
    const register = async (payload) => {
        const r = await api.post("/auth/register", payload);
        setAuthToken(r.data.token);
        setUser(r.data.user);
        return r.data.user;
    };
    const logout = () => { setAuthToken(null); setUser(null); };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
